export class ProductPagination {
  constructor(elem) {
    this._refs = {
      el: elem,
      currentUrl: window.location.href,
      // Get values and convert to number for math later
      currentSkip: elem.querySelector('[id*="_loadMoreSkip"]').value,
      currentTake: elem.querySelector('[id*="_loadMoreTake"]').value,
    };

    // These two values are mandatory
    if (!this._refs.currentSkip || !this._refs.currentTake) return;
    this.init();
  }

  init() {
    this.createTemplate();
    this.updateCurrentCount();
    this.showProductCountLabel();
    this.watchPaginationChanges();
  }

  showProductCountLabel() {
    this._refs.el.querySelector('.productCount')?.classList.remove('is-hidden');
  }

  updateCurrentCount() {
    const currentCountElement = this._refs.el.querySelector('.current_count');
    if (!currentCountElement) return;
    currentCountElement.innerText = this.currentCount;
  }

  updatePage(e) {
    window.location.href = e.target.value;
  }

  watchPaginationChanges() {
    this._refs.el
      .querySelector('[name="pageNumber"]')
      .addEventListener('change', this.updatePage.bind(this));
  }

  navHelper(isDisable, pageNumber) {
    const disableClass = isDisable ? 'disabled' : '';
    const disableHref = isDisable ? '' : `href="${this.createUrl(pageNumber)}"`;
    return { disableClass, disableHref };
  }

  createPrevious() {
    const isDisable = this.currentPage === 1 || parseInt(this.totalItems) < 1;
    const { disableClass, disableHref } = this.navHelper(isDisable, this.currentPage - 2);
    return `<a class="nav d-flex justify-content-center align-items-center ${disableClass}" ${disableHref} class="previous_page">&lsaquo;</a>`;
  }

  createNext() {
    const isDisable = this.currentPage === this.totalPages || parseInt(this.totalItems) < 1;
    const { disableClass, disableHref } = this.navHelper(isDisable, this.currentPage);
    return `<a class="nav d-flex justify-content-center align-items-center ${disableClass}" ${disableHref} class="next_page">&rsaquo;</a>`;
  }

  createPageNumber() {
    let template = '';
    const pages = this.totalPages;
    for (let i = 0; i < pages; i++) {
      const pageNumber = i + 1;
      const url = this.createUrl(i);
      template += `
                <option value="${url}" data-page="${pageNumber}"  ${
        this.currentPage === pageNumber ? 'selected' : ''
      }>${pageNumber}</option>
            `;
    }
    return template;
  }

  createTemplate() {
    const wrapper = this._refs.el.querySelector('.v-pagination');
    if (!wrapper) return;
    const pageNumber = this.createPageNumber();
    const previous = this.createPrevious();
    const next = this.createNext();

    wrapper.innerHTML = `
            ${previous}
            <div class="form-select" data-select>
                <select name="pageNumber">
                    ${pageNumber}
                </select>
            </div>
            ${next}
        `;
  }

  urlCheck(currentUrl) {
    // different parameters are split by $, value is split by !
    // if there is at least one value add parameter split at the end
    // if there is no value we need to make sure to add / at the end of main page - ordering and add parameters latter
    if (currentUrl.indexOf('!') > -1) {
      return (currentUrl = currentUrl + '$');
    }
    return (currentUrl = currentUrl + '/');
  }

  createUrl(page) {
    /* eslint-disable-next-line */
    const baseUrl = this._refs.currentUrl.replace(/[$,\/]*take!.*/, '');
    const currentUrl = this.urlCheck(baseUrl);
    const currentSkip = parseInt(this._refs.currentTake) * page;
    const newUrl = currentUrl + 'take!' + this._refs.currentTake + '$skip!' + currentSkip;
    return newUrl;
  }

  get totalPages() {
    if (!this.totalItems) return 0;
    const calcNumberOfPages = Math.ceil(
      parseInt(this.totalItems) / parseInt(this._refs.currentTake),
    );
    return calcNumberOfPages;
  }

  get currentPage() {
    return Math.ceil(this.currentSkip / parseInt(this._refs.currentTake));
  }

  get currentSkip() {
    return parseInt(this._refs.currentSkip) + parseInt(this._refs.currentTake);
  }

  get currentCount() {
    let count = this.currentSkip;
    if (count > this.totalItems) {
      count = this.totalItems;
    }
    return count;
  }

  get totalItems() {
    const countElement = document.querySelector('[data-total-count]');
    if (!countElement) return 0;
    const totalCountValue = countElement.dataset.totalCount;
    return totalCountValue;
  }
}
